import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { ProductCategory, FilterState } from '../types';
import { DEFAULT_SHARING_FILTERS, SharingCategory, SharingFilters } from '../utils/sharing';

interface UIStore {
  isSearchActive: boolean;
  setSearchActive: (active: boolean) => void;

  isKeyboardOpen: boolean;
  setKeyboardOpen: (open: boolean) => void;

  homeCategory: ProductCategory | 'all';
  setHomeCategory: (cat: ProductCategory | 'all') => void;

  homeFilters: FilterState;
  setHomeFilters: (f: FilterState) => void;

  homeSearchQuery: string;
  setHomeSearchQuery: (q: string) => void;

  // Раздел «Шеринг»: свой поиск, раздел и фильтры — переживают переход в карточку и обратно
  sharingCategory: SharingCategory;
  setSharingCategory: (cat: SharingCategory) => void;

  sharingFilters: SharingFilters;
  setSharingFilters: (f: SharingFilters) => void;

  sharingSearchQuery: string;
  setSharingSearchQuery: (q: string) => void;
}

const defaultFilters: FilterState = {
  platforms: [],
  priceRange: [0, 22400],
  languages: [],
  categories: [],
  regions: [],
};

export const useUIStore = create<UIStore>()(
  persist(
    (set) => ({
      isSearchActive: false,
      setSearchActive: (active) => set({ isSearchActive: active }),

      isKeyboardOpen: false,
      setKeyboardOpen: (open) => set({ isKeyboardOpen: open }),

      homeCategory: 'all',
      setHomeCategory: (cat) => set({ homeCategory: cat }),

      homeFilters: defaultFilters,
      setHomeFilters: (f) => set({ homeFilters: f }),

      homeSearchQuery: '',
      setHomeSearchQuery: (q) => set({ homeSearchQuery: q }),

      sharingCategory: 'all',
      setSharingCategory: (cat) => set({ sharingCategory: cat }),

      sharingFilters: DEFAULT_SHARING_FILTERS,
      setSharingFilters: (f) => set({ sharingFilters: f }),

      sharingSearchQuery: '',
      setSharingSearchQuery: (q) => set({ sharingSearchQuery: q }),
    }),
    {
      name: 'ps_store_ui',
      storage: createJSONStorage(() => sessionStorage),
      // Persist only the fields the user expects to survive navigation
      partialize: (s) => ({
        homeCategory: s.homeCategory,
        homeFilters: s.homeFilters,
        homeSearchQuery: s.homeSearchQuery,
        sharingCategory: s.sharingCategory,
        sharingFilters: s.sharingFilters,
        sharingSearchQuery: s.sharingSearchQuery,
      }),
    },
  ),
);
